import { render, staticRenderFns } from "./BookmarkFilter.vue?vue&type=template&id=5abab49d&scoped=true"
import script from "./BookmarkFilter.vue?vue&type=script&lang=js"
export * from "./BookmarkFilter.vue?vue&type=script&lang=js"
import style0 from "./BookmarkFilter.vue?vue&type=style&index=0&id=5abab49d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abab49d",
  null
  
)

export default component.exports